import { render, staticRenderFns } from "./IlluminancePage.vue?vue&type=template&id=b54876a4"
import script from "./IlluminancePage.vue?vue&type=script&lang=js"
export * from "./IlluminancePage.vue?vue&type=script&lang=js"
import style0 from "./IlluminancePage.vue?vue&type=style&index=0&id=b54876a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports